import { useState } from "react";

const NAV_ITEMS = [
  { id: "home",     label: "Home" },
  { id: "about",    label: "About" },
  { id: "features", label: "Features" },
  { id: "contact",  label: "Contact" },
];

export default function Navbar({ page, nav, scrolled }) {
  const [open, setOpen] = useState(false);

  const handleNav = (id) => {
    nav(id);
    setOpen(false);
  };

  return (
    <>
      <nav className={`nav${scrolled ? " scrolled" : ""}`}>
        <div className="logo" onClick={() => handleNav("home")}>
          <img src="/logo.png" alt="Ooon Logo" className="logo-img" />
        </div>

        <ul className="nav-links">
          {NAV_ITEMS.map((item) => (
            <li key={item.id}>
              <button
                className={page === item.id ? "active" : ""}
                onClick={() => handleNav(item.id)}
              >
                {item.label}
              </button>
            </li>
          ))}
          <li>
            <a
              href="https://ooon.buypapps.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-cta"
            >
              Login / Sign Up
            </a>
          </li>
        </ul>

        <div className="hamburger" onClick={() => setOpen(!open)}>
          <span /><span /><span />
        </div>
      </nav>

      {/* Mobile menu */}
      <div className={`mobile-menu${open ? " open" : ""}`}>
        {NAV_ITEMS.map((item) => (
          <button key={item.id} onClick={() => handleNav(item.id)}>
            {item.label}
          </button>
        ))}
        <a
          href="https://ooon.buypapps.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="m-cta"
          style={{ display: "block", padding: "13px", fontWeight: 700, borderRadius: 10, background: "var(--g1)", color: "var(--lime2)", textAlign: "center", marginTop: 8 }}
        >
          Login / Sign Up
        </a>
      </div>
    </>
  );
}
